// import React, { useState } from 'react'
// import { Box, Stack, TextField, Typography } from '@mui/material'
// import ButtonCommon from '../CommonComponents/ButtonCommon'
// import { ReactComponent as MCPlogo } from "../static/Icons/mcp-logo.svg";
// import { SignUp } from '@clerk/clerk-react';
// import { useNavigate } from 'react-router-dom';

// export default function ConfirmationCode() {
//     const navigate = useNavigate();
//     const [verificationCode, setVerificationCode] = useState(Array(6).fill(""));
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const handleVerificationChange = (e, index) => {
//         const value = e.target.value.replace(/[^0-9]/g, "");
//         if (!value) return;

//         const newCode = [...verificationCode];
//         newCode[index] = value[0];
//         setVerificationCode(newCode);

//         // Move to next input
//         if (index < 5) {
//             document.getElementById(`otp-input-${index + 1}`)?.focus();
//         }
//     };

//     const handleOtpKeyDown = (e, index) => {
//         if (e.key === "Backspace") {
//             const newCode = [...verificationCode];
//             if (newCode[index]) {
//                 newCode[index] = "";
//                 setVerificationCode(newCode);
//             } else if (index > 0) {
//                 document.getElementById(`otp-input-${index - 1}`)?.focus();
//             }
//         }

//         if (e.key === "ArrowLeft" && index > 0) {
//             document.getElementById(`otp-input-${index - 1}`)?.focus();
//         }

//         if (e.key === "ArrowRight" && index < 5) {
//             document.getElementById(`otp-input-${index + 1}`)?.focus();
//         }
//     };

//     const handleVerifyEmail = async (e) => {
//         e.preventDefault();
//         setError("");
//         setLoading(true);

//         const code = verificationCode.join(""); // Combine digits

//         try {
//             const result = await SignUp.attemptEmailAddressVerification({ code });

//             if (result.status === "complete") {
//                 await setActive({ session: result.createdSessionId });
//                 navigate("/login");
//             } else {
//                 setError("Verification failed with status: " + result.status);
//             }
//         } catch (err) {
//             console.error("Verification error:", err);
//             setError(
//                 err.errors?.[0]?.message || "Verification failed. Please try again."
//             );
//         } finally {
//             setLoading(false);
//         }
//     };


//     return (
//         <Box sx={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 5, bgcolor: '#2B2B2B', color: '#FFFFFF' }}>
//             <Box
//                 component={MCPlogo}
//                 sx={{
//                     width: 250,
//                     height: 60,
//                 }}
//             />
//             <Box sx={{ border: '1px solid #BCBCBC', borderRadius: '8px', p: 2, textAlign: 'center' }}>
//                 <Typography variant='h6' gutterBottom>Confirmation Code</Typography>

//                 <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 2 }}>
//                     {verificationCode.map((digit, index) => (
//                         <TextField
//                             key={index}
//                             id={`otp-input-${index}`}
//                             value={digit}
//                             onChange={(e) => handleVerificationChange(e, index)}
//                             onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                             inputProps={{
//                                 maxLength: 1,
//                                 style: {
//                                     textAlign: "center",
//                                     fontSize: "18px",
//                                     color: "#BCBCBC",
//                                 },
//                             }}
//                             sx={{
//                                 width: "40px",
//                                 height: "40px",
//                                 "& .MuiOutlinedInput-root": {
//                                     borderRadius: "8px",
//                                     "& fieldset": { borderColor: "#BCBCBC" },
//                                     "&:hover fieldset": { borderColor: "#BCBCBC" },
//                                     "&.Mui-focused fieldset": { borderColor: "#BCBCBC" },
//                                 },
//                             }}
//                             type="tel"
//                             variant="outlined"
//                             size="small"
//                         />
//                     ))}
//                 </Stack>

//                 <ButtonCommon variant='contained' sx={{ borderRadius: '50px' }}>
//                     Submit
//                 </ButtonCommon>
//             </Box>
//         </Box>
//     )
// }


























import React, { useState } from 'react';
import {
    Box,
    Stack,
    TextField,
    CircularProgress,
    Alert,
} from '@mui/material';
import ButtonCommon from '../CommonComponents/ButtonCommon';
import { useSignUp, useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

export default function ConfirmationCode() {
    const navigate = useNavigate();
    const { signUp } = useSignUp();
    const { setActive } = useClerk();

    const [verificationCode, setVerificationCode] = useState(Array(6).fill(''));
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleVerificationChange = (e, index) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        if (!value) return;

        const newCode = [...verificationCode];
        newCode[index] = value[0];
        setVerificationCode(newCode);

        // Move to next input
        if (index < 5) {
            document.getElementById(`otp-input-${index + 1}`)?.focus();
        }
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            const newCode = [...verificationCode];
            if (newCode[index]) {
                newCode[index] = '';
                setVerificationCode(newCode);
            } else if (index > 0) {
                document.getElementById(`otp-input-${index - 1}`)?.focus();
            }
        }

        if (e.key === 'ArrowLeft' && index > 0) {
            document.getElementById(`otp-input-${index - 1}`)?.focus();
        }

        if (e.key === 'ArrowRight' && index < 5) {
            document.getElementById(`otp-input-${index + 1}`)?.focus();
        }
    };

    const handleVerifyEmail = async () => {
        // e.preventDefault();
        setError('');
        setLoading(true);

        const code = verificationCode.join('');

        try {
            const result = await signUp.attemptEmailAddressVerification({ code });

            if (result.status === 'complete') {
                await setActive({ session: result.createdSessionId });
                navigate('/login');
            } else {
                setError('Verification failed with status: ' + result.status);
            }
        } catch (err) {
            console.error('Verification error:', err);
            setError(
                err.errors?.[0]?.message || 'Verification failed. Please try again.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 5, bgcolor: '#2B2B2B', color: '#FFFFFF' }}>
            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 2, height: 'fit-content' }}>
                {verificationCode.map((digit, index) => (
                    <TextField
                        key={index}
                        id={`otp-input-${index}`}
                        value={digit}
                        onChange={(e) => handleVerificationChange(e, index)}
                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        inputProps={{
                            maxLength: 1,
                            style: {
                                textAlign: 'center',
                                fontSize: '18px',
                                color: '#BCBCBC',
                            },
                        }}
                        sx={{
                            width: '40px',
                            height: '40px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                '& fieldset': { borderColor: '#BCBCBC' },
                                '&:hover fieldset': { borderColor: '#BCBCBC' },
                                '&.Mui-focused fieldset': { borderColor: '#BCBCBC' },
                            },
                        }}
                        type="tel"
                        variant="outlined"
                        size="small"
                    />
                ))}
            </Stack>

            {error && (
                <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                    {error}
                </Alert>
            )}

            <ButtonCommon
                type="submit"
                variant="contained"
                sx={{ borderRadius: '50px', width: '100%' }}
                disabled={loading}
                onClick={handleVerifyEmail}
            >
                {loading ? <CircularProgress size={22} sx={{ color: '#000' }} /> : 'Submit'}
            </ButtonCommon>
        </Box>
    );
}